import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { addVisitedPath } from '@/lib/helpers/visitedPaths'
import { pathToLabel } from '@/lib/helpers/pathToLabel'

const SKIP_PATHS = ['/', '/login', '/reset_password', '/not-found']

export default function useRecordVisitedPath(): void {
  const { pathname } = useLocation()

  useEffect(() => {
    if (SKIP_PATHS.includes(pathname)) return
    // Skip bare /project_stages and /project_stages/:id (redirect-only routes)
    if (/^\/project_stages(\/[^/]+)?$/.test(pathname)) return

    const { labelKey, labelFallback, detail } = pathToLabel(pathname)
    addVisitedPath({ path: pathname, labelKey, labelFallback, detail })
  }, [pathname])
}
